<template>
    <form-row title="Payments">
        <input-money
            :value="mortgage.payments"
            name="payments"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
